import * as types from "./../types";
import SslService from "./../../services/Ssl.Service";
import { funcUpdateAppStateAfterResponse } from "./AppStateActions";
import { funcSaveIngestion2ServiceResponse } from "./CardListActions";
import { getAddress, getVisionAddress, getGEMID1, getGEMID2,getTrackState } from "../../shared/utility";
import { getScreen, getSSLData, getUserDetails } from "../../shared/TrackRetUtility";
import { SetTokenValues } from "../../shared/SharedUtility";
import GlobalService from "../../services/GlobalService";
import { isPartnerChannelCode, getPartnerAddress } from "../../shared/PartnerUtility";
import TelcoService from "../../services/Telco.Service";
import { fetchDumpData, setDumpBased } from "./DumpDataAction";

const initState = { isSaved: true, currentAction: "", isSubmited: true, isSubmitedSuccess: false, loading: false, error: null, };
let payload = {};
let errorState = {};
export const funcValidateOtpAndUpdateSSL = (sslInputData, otpInput, cardType) => async (dispatch) => {
  dispatch({ type: types.LOADING_VIEW_STATE, value: true, });
  /*********Checking if customer came from c2b journey or eapply retrive home page and if it is a non consented lead ***************/
  const localStorgemid1 = getGEMID1();
  const localStorgemid2 = getGEMID2();
  const c2bRetargetIdentifier = "C2B";
  const middleNameval = sslInputData.middleName ? sslInputData.middleName.trim() : "";
  let personalDetails = {
    shortCode: sslInputData.shortCode,
    cardType: cardType,
    firstName: sslInputData.firstName,
    middleName: middleNameval,
    lastName: sslInputData.lastName,
    mobileNumber: sslInputData.mobileNo,
    consentFlag: "Y",
  };
  if (otpInput) {
    personalDetails.otp = otpInput;
    personalDetails.reasonCode = "101";
  }
  let currentActionState = otpInput ? "UpdateConsent" : "UpdateConsentInCreateSSL";
  if ((localStorgemid1 && localStorgemid1.includes(c2bRetargetIdentifier)) || (localStorgemid2 && localStorgemid2.includes(c2bRetargetIdentifier))) {
    // channel(lg channel) and source code(lg scource) to be changed 
    // localStorage.setItem("sourceCode",  sslInputData?.sourceCode); // LG soure code
    personalDetails.channelCode = sslInputData.channelCode;
    personalDetails.sourceCode = "DC";
    localStorage.setItem("sourceCode","DC");
    //personalDetails.sourceCode = sslInputData.sourceCode ? sslInputData.sourceCode : "";
  } else {
    personalDetails.channelCode = "SAPL";
    personalDetails.sourceCode = "WEBS";
    // localStorage.setItem("sourceCode",  sslInputData?.sourceCode); 
    // channel(SAPL) and source code(WEBS) to be changed 
    localStorage.setItem("sourceCode","WEBS");
  }
  // new lead consent composite api to be called
  const update_consent_response = await SslService.funcValidateOtpAndUpdateSsl(personalDetails, otpInput);
  if (update_consent_response && update_consent_response.data) {
    const dataset = update_consent_response.data.data;
    const consent_update_statusCode = update_consent_response.data.statusCode;
    if (consent_update_statusCode === "000") {
      //payload = { ...initState, currentAction: currentActionState, consentFlag:"Y", isSaved: true, isSubmited: true, isSubmitedSuccess: true, loading: false, };
      payload = { ...initState, currentAction: currentActionState, isSaved: true, isSubmited: true, isSubmitedSuccess: true, loading: false, };
      
      errorState = null;
     // dataset["consentFlag"] = "Y";
    }
    else if (consent_update_statusCode === "001") {
      /*if (dataset.applicationNumber && dataset.applicationNumber.length > '1' && dataset.applicationNumber !== '0') {
        payload = { ...initState, currentAction: "UpdateConsentMatchTrack", isSaved: true, isSubmited: true, isSubmitedSuccess: false, loading: false, };
        errorState = null;
        // this case if track service is need to call not used now
      }
      else {*/
        //UpdateConsentMatchRet
        if(cardType === dataset.cardType){
          currentActionState = "UpdateConsentSameCardLeadRet";//lead name and mobile card type alls are smae  
        }else{
          currentActionState = "UpdateConsentDiffCardLeadRet";//lead name and mobile are same
        }
        payload = { ...initState, currentAction: currentActionState, isSaved: true, isSubmited: true, isSubmitedSuccess: false, loading: false, };
        errorState = null;
      /* } */
      localStorage.setItem("hsToken", dataset.hsToken);
      localStorage.setItem("cardTypeLocal", dataset.cardType);
    } else {
      // FMEA 999 case
      payload = { ...initState, currentAction: currentActionState, isSubmited: true, isSubmitedSuccess: false, loading: false, };
      errorState = { errorCode: update_consent_response.data.statusCode, errorMsg: update_consent_response.data.message, };
    }
  } else {
    payload = { ...initState, currentAction: currentActionState, isSubmited: true, isSubmitedSuccess: false, loading: false, error: update_consent_response?.data?.message, };
    errorState = null;
  }
  dispatch(funcUpdateAppStateAfterResponse(payload, errorState));
}

export const funcValidateOtpAndCreateSSL = (sslInputData, otpInput, cardType, productType, dumpData) => async (dispatch) => {
  dispatch({ type: types.LOADING_VIEW_STATE, value: true, });

  const response = await SslService.funcValidateOtpAndCreateSsl(sslInputData, otpInput, cardType, productType, dumpData);
   let doStateUpd=true;
  if (response.data.data?.shortCode && response.data.data?.shortCode !== "") {
	       localStorage.setItem("shortCode", response.data.data.shortCode);
	      }     
  if (response && response.data) {
    const statusCode = response.data.statusCode;
    if (statusCode === "000" || statusCode === "001") {
      payload = { ...initState, currentAction: "ValidateOTP", dataFilled: true, loading: false, };
      dispatch({ type: types.VALIDATE_OTP_CREATE_SSL, payload: response.data, });
      payload["isSubmitedSuccess"] = true;
      errorState = null;
      // check for oauth token in the 
      if (response.data?.accessToken && response.data?.sbicUserFgp) {
        const resToken = { accessToken: response.data?.accessToken, cookie: response.data.sbicUserFgp, visitorId: response.data?.visitorID };
        GlobalService.setOAuthToken(resToken);
        SetTokenValues(resToken, true);
      }
      if(response.data.data?.cardType)
      dispatch({type:types.SAVE_NETWORK_CARDTYPE,payload:response.data.data?.cardType});  
    } else if (statusCode === "002") {
      /**flow come here when retrieve from sprint home page-sree **/
      const dataset = response.data.data;
      dataset["mobileNo"] = response.data.data?.mobileNumber;
      delete dataset.mobileNumber;
      if (!response.data.data?.cardType) {
        dataset['cardType'] = "";
      }
      if (dataset["state"]) {
        //dispatch({ type: types.SAVE_PERSONAL_DETAILS, payload: dataset, });
        errorState = null;
        payload["isUserRetrieve"] = true;
        const sslData = getSSLData(response.data.data);

        dispatch({ type: types.VALIDATE_OTP_CREATE_SSL, payload: { data: sslData }, });

        if (response.data?.data?.vPlusAddress) {
          let res = {
            vPlusResiAddress: response.data?.data && response.data?.data?.vPlusAddress ? response.data?.data?.vPlusAddress : null,
            visionMothersName: response.data?.data && response.data?.data?.vPlusMotherName ? response.data?.data?.vPlusMotherName : "",
            visionEmailId: response.data?.data && response.data?.data?.vPlusEmailId ? response.data?.data?.vPlusEmailId : "",
            dSignVPlusMotherName: response.data?.data && response.data?.data?.dSignVPlusMotherName ? response.data?.data?.dSignVPlusMotherName : "",
            dSignVPlusEmailId: response.data?.data && response.data?.data?.dSignVPlusEmailId ? response.data?.data?.dSignVPlusEmailId : "",
            dSignVPlusResiAddress: response.data?.data && response.data?.data?.dSignVPlusResiAddress ? response.data?.data?.dSignVPlusResiAddress : ""
          };
          let vAddress = res.vPlusResiAddress;
          const vPlusResiAddress = getVisionAddress(vAddress);
          dispatch(funcStoreVisionAddress({ ...res, vPlusResiAddress }));
        }
        const screenDetails = getScreen(sslData);
        if(sslInputData.coreCardChannel && sslInputData.coreCardChannel !==""){
           dataset['coreCardChannel'] = sslInputData.coreCardChannel;
        }
        /**********When Lead Is NON-Consented Start**************/
        
        if (response.data?.data?.hasOwnProperty('consentFlag') && response.data.data.consentFlag === "N") {
          otpInput = "";
          const middleNameval = sslInputData.middleName ? sslInputData.middleName.trim() : "";
          const cardChannel = (sslInputData.coreCardChannel && sslInputData.coreCardChannel !=="") ?  sslInputData.coreCardChannel : response.data.data.channelCode;
          //const cardChannel =  (response.data.data.channelCode === "OMLG" || (coreCardChannel && coreCardChannel !== "")) ? "OMLG" : "SAPL";
          let personalDetails = {
            shortCode: response.data.data.shortCode,
            channelCode: cardChannel,
            firstName: sslInputData.firstName,
            lastName: sslInputData.lastName,
            middleName: middleNameval,
            mobileNumber: sslInputData.mobileNo,
            consentFlag: "Y",
            sourceCode: "WEBS"
          };
          if(cardType === response.data.data?.cardType)
          personalDetails.cardType = cardType
          const update_consent_response = await SslService.funcValidateOtpAndUpdateSsl(personalDetails, otpInput, cardType);
          if (update_consent_response && update_consent_response.data) {
            const consent_update_statusCode = update_consent_response.data.statusCode;
            if (consent_update_statusCode === "000") {
              payload = { ...initState, currentAction: "UpdateConsentInCreateSSL", screenName: screenDetails.goTo, isUserRetrieve: true, loading: false };
              dataset["consentFlag"] = "Y";
             // dispatch({ type: types.SAVE_PERSONAL_DETAILS, payload: dataset, });
            } else {
              payload = { ...initState, currentAction: "UpdateConsentInCreateSSL", isUserRetrieve: false, dataFilled: false, loading: false, };
              errorState = { errorCode: update_consent_response.data.statusCode, errorMsg: update_consent_response.data.message, };
            }
          } else {
            payload = { ...initState, currentAction: "UpdateConsentInCreateSSL", dataFilled: false, isUserRetrieve: false, loading: false, error: update_consent_response?.data?.message, };
            errorState = { errorCode: update_consent_response?.data?.statusCode, errorMsg: update_consent_response?.data?.message, };
          }
          localStorage.setItem("sourceCode","WEBS");
          dataset["channelCode"] = cardChannel;
         // dataset["channelCode"] = (response.data.data.channelCode === "OMLG" || (coreCardChannel && coreCardChannel !== "")) ? "OMLG" : "SAPL";
          /**********When Lead Is NON-Consented End**************/
        } else {
          const lg_lite_partner_chanel = window.global.config?.LG_LITE_PARTNER_CHANEL;
          if(lg_lite_partner_chanel.includes(dataset['channelCode']))
          localStorage.setItem("sourceCode", "DC");
          if(response.data?.data?.isDumpBased==="Y" && response.data?.data?.employeeId){
            doStateUpd = false;
            if(dataset.isDumpBased==="Y")
            dispatch({ type: types.SAVE_IS_DUMP_BASED, payload:true});
            dispatch(fetchDumpData({ employeeId:response.data?.data?.employeeId , isSprintDumpTrackRetrieve : true}, "employee_validation"));
          }else{
          payload = {
            ...initState,
            // isSubmited: true,
            //isSubmitedSuccess: true,
            screenName: screenDetails.goTo,
            isUserRetrieve: true,
            loading: false,
          };
        }
        }
        let data = {
          posRequired: response.data.data?.posRequired,
          surrogateStatus:response.data.data?.surrogateStatus,
          surrogateList:response.data.data?.surrogateList,
          posCreditLimit:response.data.posCreditLimit,
          finalCreditLimit:response.data.finalCreditLimit,
      }
      dispatch({ type: types.SAVE_SURROGATE_DATA,payload:data});
      
        dispatch({ type: types.SAVE_PERSONAL_DETAILS, payload: dataset, });
		 if(response.data.data?.cardType)
        dispatch({type:types.SAVE_NETWORK_CARDTYPE,payload:response.data.data?.cardType});
      }
      else {
        payload = { ...initState, currentAction: "ValidateOTP", isSubmitedSuccess: false, dataFilled: false, loading: false, };
        errorState = {
          errorCode: "999",
          errorMsg: "Invalid state",
          //invalidOtpAttemptCount: response.data.data?.invalidOtpAttemptCount,
        };
      }
    } else if (response.data.statusCode === "003") {
      const dataset = response.data.data;
      const lg_lite_partner_chanel = window.global.config?.LG_LITE_PARTNER_CHANEL;
      if(lg_lite_partner_chanel.includes(dataset['channelCode'])) 
      localStorage.setItem("sourceCode", "DC");
      let user = getUserDetails(response.data.data);
      if (response.data?.data?.vPlusAddress) {
        let res = {
          vPlusResiAddress: response.data?.data && response.data?.data?.vPlusAddress ? response.data?.data?.vPlusAddress : null,
          dSignVPlusResiAddress: response.data?.data && response.data?.data?.dSignVPlusResiAddress ? response.data?.data?.dSignVPlusResiAddress : ""
        };
        let vAddress = res.vPlusResiAddress;
        const vPlusResiAddress = getVisionAddress(vAddress);
        dispatch(funcStoreVisionAddress({ ...res, vPlusResiAddress }));
      }

      if(response.data.data.blazeFungibleFlag === 'Y'){
          const fungibleData = {
            fungibleFlag : response.data.data.blazeFungibleFlag, 
            fungibleCurrLimit : response.data.data.fungibleCurrXpos , 
            fungibleIncLimit : response.data.data.fungibleIncLimit
          }
        dispatch({ type: types.SAVE_FUNGIBLE_DATA, payload: fungibleData});
      }
      const dumpTrackCodes = ["TR001", "TR002" , "TR003" ,"TR011", "TR013" , "TR024", "TR031"];
      if(dataset.dumpAppFlag && dumpTrackCodes.includes(user?.state))
        dispatch({ type: types.SAVE_IS_DUMP_BASED, payload: true });

      if(dataset?.differentlyAbledStatus !== undefined && dataset?.differentlyAbledStatus !== null && dataset?.differentlyAbledStatus !== false){
            const disabilityData = {
                "differentlyAbledStatus": dataset?.differentlyAbledStatus,
                "udidNumber": dataset?.udidNumber,
                "typeOfImpairment": dataset?.typeOfImpairment,
                "percentageOfImpairment": dataset?.percentageOfImpairment,
                "brailleCard": dataset?.brailleCardRequired ? dataset?.brailleCardRequired : null
            }
            dispatch({type : types.LOCAL_DISABILITY_DATA , payload:disabilityData});
        }

      if(response.data.data.earlyCreditDecPartner && response.data.data.earlyCreditDecPartner === 'Y'){
          dispatch({type : types.SAVE_EARLY_CREDIT_FLAG , payload :response.data.data.earlyCreditDecPartner})
      }


      if (isPartnerChannelCode(response.data?.data?.channelCode) || (response.data.data?.earlyCreditDecPartner && response.data.data?.earlyCreditDecPartner === 'Y')) {
        dispatch({
          type: types.SAVE_PARTNER_DATA,
          payload: {
            channelCode: response.data?.data?.channelCode,
            contactDetails: getPartnerAddress(response.data?.data?.contactDetails),
            inbmitcScreen: response.data?.data?.inbmitcScreen,
            autoSweepReceived:response.data?.data?.autoSweepDetailsBO?.autoSweepReceived,
            autoDebitReceived:response.data?.data?.autoDebitDetailsBO?.autoDebitReceived,
            paymentOption:response.data?.data?.autoDebitDetailsBO?.paymentOption,
            blazeAdFlag:response.data?.data?.blazeAdFlag,
            blazeAsFlag:response.data?.data?.blazeAsFlag,
            accNoOnAutoDebit:response.data?.data?.autoDebitDetailsBO?.accNoOnAutoDebit ?response.data?.data?.autoDebitDetailsBO?.accNoOnAutoDebit:"XXXXXXXXXXXX" ,
            platformIndicator: response.data?.data?.platformIndicator,
            inbFlag: response.data?.data?.inbFlag,
            partnerUUID: response.data?.data?.partnerUUID,
            yonoUUID: response.data?.data?.yonoUUID,
            fdAccountNo: response.data?.data?.fdAccountNo,
            savingsAccountNo: response.data?.data?.savingsAccountNo,
            holdAmount: response.data?.data?.holdAmount,          
          }
        });
      }
      dispatch({  type: types.SAVE_TELCO_FLAGS_FOR_EKYC_JOURNEY, payload: {
          ekycJourneytelcoFLag: dataset['telcoFLag'],// saving telco flag to pass in kyc search for banka 
          ekycJourneytelcoReason: dataset['telcoReason']
      }});
      dispatch({
        type: types.SAVE_CKYC_DATA,
        payload: { applicationNumber: response.data.data?.applicationNumber, gender: response.data.data?.ckycGender },
      });
      if (response.data.data?.stpAddressList && response.data.data?.stpAddressList.length) {
          dispatch({
            type: types.SAVE_DIGILOCKER_DATA,
            payload: {
              gender: response.data.data?.kycGender,
              address: response.data.data?.stpAddressList ? response.data.data?.stpAddressList : null,
              document: response.data.data?.stpDocumenList ? response.data.data.stpDocumenList : null,
              kycValid :response.data.data?.kycValid,
              kycCompletedTimestamp:response.data.data?.kycCompletedTimeStamp ? response.data.data.kycCompletedTimeStamp : null
            },
          });
          const notCKYCFlow = (dataset?.stpDocumenList?.[0]?.docCode=== "CKYC" &&  dataset?.stpDocumenList?.length === 1) ? false : true ;
          dispatch({ type: types.SAVE_RESIADD_FLAGS, payload: { screenFlow: response.data.data?.stpAddressList[0]?.oclPinCodeFlag === true && notCKYCFlow ? "manual" :  user.state === "TR024" && notCKYCFlow ? "digiSplitManual" : "digiAndManual" }, });
          dispatch({ type: types.SAVE_BRE_ASSISTED_FLAG, payload: {stpBreAssisted: response.data.data?.stpBreAssisted ? response.data.data?.stpBreAssisted : ""} });
          dispatch({ type: types.SAVE_FACE_TO_FACE_FLAG, payload: { faceToFace: response.data.data?.faceToFace ? response.data.data?.faceToFace : ""} });
        }
        else {
          if(dataset?.stpDocumenList && dataset?.stpDocumenList.length > 0 && dataset?.stpDocumenList[0]?.docCode=== "CKYC" ){
              dispatch({
              type: types.SAVE_DIGILOCKER_DATA,
              payload: { gender: response.data.data?.kycGender, address: null, document: dataset?.stpDocumenList, kycValid :response.data.data?.kycValid, kycCompletedTimestamp:response.data.data?.kycCompletedTimeStamp ? response.data.data.kycCompletedTimeStamp : null },
          });
          }
          else{
          dispatch({
            type: types.SAVE_DIGILOCKER_DATA,
            payload: { gender: response.data.data?.kycGender, address: null, document: null, kycValid :response.data.data?.kycValid, kycCompletedTimestamp:response.data.data?.kycCompletedTimeStamp ? response.data.data.kycCompletedTimeStamp : null},
            
          });
          }
          dispatch({ type: types.SAVE_RESIADD_FLAGS, payload: { screenFlow: "manual" }, });
          dispatch({ type: types.SAVE_BRE_ASSISTED_FLAG, payload: {stpBreAssisted: response.data.data?.stpBreAssisted ? response.data.data?.stpBreAssisted : ""} });
          dispatch({ type: types.SAVE_FACE_TO_FACE_FLAG, payload: { faceToFace: response.data.data?.faceToFace ? response.data.data?.faceToFace : ""} });
        }

      if (user.state === "TR001") {
        let addr = getAddress(response.data.data?.stpAddressList, "CKYC");
        dispatch({
          type: types.SAVE_CKYC_DATA,
          payload: {
            applicationNumber: response.data.data?.applicationNumber,
            resiAddr: addr ? addr[0] : null,
            gender: response.data.data?.ckycGender,
            kin: response.data.data?.kin ? response.data.data.kin : "",
          }
        });
        if (!addr.length) {
          user.state = "TR002";
        }
      } else if (user.state === "TR003") {
        let addr = getAddress(response.data.data?.stpAddressList, "DEMOG");
        dispatch({ type: types.VALIDATE_OTP_CREATE_SSL, payload: { data: { resiAddr: addr } }, });
        if (addr.length) {
          dispatch({ type: types.SAVE_RESIADD_FLAGS, payload: { screenFlow: "demoAndManual" }, });
        } else {
          dispatch({ type: types.SAVE_RESIADD_FLAGS, payload: { screenFlow: "manual" }, });
        }
      }
      // else if (user.state === "TR010") {
      //   dispatch({ type: types.IS_ACCOUNT_VALIDATION_FAILED, payload: false, });
      // }
      else if (getTrackState(user.state)) {
        if (response.data.data?.downsellCardList || response.data.data?.finalCreditLimit || response.data.data?.posCreditLimit || response.data.data?.stpDocumenList) {
          
          const data = {
            currentCardType: response.data.data?.currentCardType,
            eligibleCardTypes: response.data.data?.downsellCardList && response.data.data?.downsellCardList.length ? response.data.data.downsellCardList : null,
            documents: response.data.data?.stpDocumenList,
            finalCreditLimit: parseInt(response.data.data?.posCreditLimit) ? response.data.data?.posCreditLimit: response.data.data?.finalCreditLimit,
            stpFlag: response.data.data?.stpFlag,
            vkycOptFlag : response.data.data?.vkycOptFlag,
            mitcOtpConsentDate : response.data.data?.mitcOtpConsentDate,
            vkycAgentDecisionReason: response.data.data?.vkycAgentDecisionReason ? (response.data.data?.vkycAgentDecisionReason).toUpperCase():"",
            vkycAgentDecision :response.data.data?.vkycAgentDecision ? (response.data.data?.vkycAgentDecision).toUpperCase():"",
            mitcOtpConsentTaken: response.data.data?.mitcOtpConsentTaken,
            stpBreAssisted: response.data.data?.stpBreAssisted ? response.data.data?.stpBreAssisted : "",
            faceToFace: response.data.data?.faceToFace ? response.data.data?.faceToFace : ""
          }
          dispatch({ type: types.SAVE_INGESTION2_RESPONSE, payload: data });
        }
        else if(user.state === "TR023"){
          const data = {
            currentCardType: response.data.data?.currentCardType,
             eligibleCardTypes: response.data.data?.downsellCardList && response.data.data?.downsellCardList.length ? response.data.data.downsellCardList : null,
            documents: response.data.data?.stpDocumenList,
            finalCreditLimit: parseInt(response.data.data?.posCreditLimit) ? response.data.data?.posCreditLimit: response.data.data?.finalCreditLimit,
            stpFlag: response.data.data?.stpFlag,
            vkycOptFlag : response.data.data?.vkycOptFlag,
            mitcOtpConsentDate : response.data.data?.mitcOtpConsentDate,
            vkycAgentDecisionReason: response.data.data?.vkycAgentDecisionReason ? (response.data.data?.vkycAgentDecisionReason).toUpperCase():"",
            vkycAgentDecision :response.data.data?.vkycAgentDecision ? (response.data.data?.vkycAgentDecision).toUpperCase():"",
            faceToFace: response.data.data?.faceToFace ? response.data.data?.faceToFace : ""
          }
          dispatch({ type: types.SAVE_INGESTION2_RESPONSE, payload: data });
        }
        if (response.data.data?.pennyDropDetails && response.data.data?.pennyDropDetails?.accountNumber) {
          dispatch({ type: types.IS_ACCOUNT_VALIDATION_FAILED, payload: false, });
        }
        if (user.state === "TR010") {
          user = { ...user, pennyCreditStatus: true };
          dispatch({
            type: types.ACCOUNT_VALIDATION, payload:
            {
              "nameMatch": response.data.data?.pennyDropDetails?.nameMatch && response.data.data?.pennyDropDetails?.nameMatch === "Y" ? true : false,
              "nameValidationByBD": true
            },
          });
        }
        else if (user.state === "TR008") {
          user = { ...user, pennyCreditStatus: true, pennyDebitStatus: true };
          if (response.data.data?.pennyDropDetails && response.data.data?.pennyDropDetails?.paymentIrn) {
            localStorage.setItem("paymentIrn", response.data.data.pennyDropDetails.paymentIrn);
          }
          dispatch({
            type: types.ACCOUNT_VALIDATION, payload:
            {
              "nameMatch": response.data.data?.pennyDropDetails?.nameMatch && response.data.data?.pennyDropDetails?.nameMatch === "Y" ? true : false,
              "nameValidationByBD": true
            },
          });
        }
      }
      else if (user.state === "ERR01" || user.state === "ERR02" || user.state === "ERR03" || user.state === "ERR04" || user.state === "ERR05" || user.state === "ERR06" || user.state === "ERR07" || user.state === "ERR08"  || user.state === "ERR09"  || user.state === "ERR10" || user.state === "ERR12" || user.state ==="ERR13" || user.state ==="ERR14" || user.state ==="ERR15" || user.state === "ERR16") {
        dispatch({ type: types.SET_WIP_STATUS, payload: { errorCode: user.state }, });
        dispatch({
          type: types.GENERIC_ERROR,
          payload: { isGenericError: false, handleClick: null, exitEvent: null, errorMessage: "" },
        });
      }
      let data = {
        posRequired: response.data.data?.posRequired,
        surrogateStatus:response.data.data?.surrogateStatus,
        surrogateList:response.data.data?.surrogateList,
        posCreditLimit:response.data.posCreditLimit,
        finalCreditLimit:response.data.finalCreditLimit,
        gstnList:response.data.data.gstnList,
        aaTriggerCount: response.data.data?.aaTriggerCount
    }
    dispatch({ type: types.SAVE_SURROGATE_DATA,payload:data});
      dispatch({ type: types.SAVE_PERSONAL_DETAILS, payload: user, });
      dispatch({ type: types.SAVE_BLAZESTP_ELIGIBLE,payload:response.data.data?.blazeStpEligible});
      if(response.data.data?.cardType && response.data.data?.cardType !== "")
        dispatch({type:types.SAVE_NETWORK_CARDTYPE,payload:response.data.data?.cardType});
      const localHsToken = localStorage.getItem("hsToken");
      localStorage.setItem("hsToken", user?.hsToken ? user.hsToken : localHsToken ? localHsToken : "");
      payload = {
        ...initState,
        //isSubmited: true,
        isUserRetrieve: true,
        isSprintTrackRetrieve: true,
        loading: false,
      };
      errorState = null;
    } else if (statusCode === "004" || statusCode === "005") {
      payload = { ...initState, currentAction: "ValidateOTP", isSubmitedSuccess: false, dataFilled: false, loading: false, };
      errorState = { errorCode: response.data?.statusCode, errorMsg: response.data.data?.hsToken, invalidOtpAttemptCount: response.data.data?.invalidOtpAttemptCount, };
      // } else if (statusCode === "101" || statusCode === "102" || statusCode === "104" || statusCode === "999") {
    } else {
      payload = { ...initState, currentAction: "ValidateOTP", isSubmitedSuccess: false, dataFilled: false, loading: false, };
      errorState = { errorCode: response.data?.statusCode, errorMsg: response.data?.message, invalidOtpAttemptCount: response.data.data?.invalidOtpAttemptCount, };
    }
  }
    if(doStateUpd)
  dispatch(funcUpdateAppStateAfterResponse(payload, errorState));
};

export const funcUpdateSSL = (userDetail, action, currentAction, screenName) => async (dispatch) => {
  dispatch({ type: types.LOADING_VIEW_STATE, value: true, });
let response;
  if(action==="ChangeNetwork"){
    let user = { 
             cardType:userDetail.cardType,
             productType: userDetail?.productType,
             priority:userDetail.priority 
           };
    response = await SslService.funcUpdateSSLByShortCodev1(user, "updateCard");
  } else {
    response = await SslService.funcUpdateSSLByShortCodev1(userDetail, action);
    
  }  
if (response && response.data) {
    const statusCode = response.data.statusCode;
    if (statusCode === "000" || statusCode === "001") {
      if(action==="ChangeNetwork"){
      payload = { ...initState, isSaved: false, isSubmited: false, isSubmitedSuccess: false, loading: false,currentAction:action};
        dispatch({ type: types.SAVE_SELECTED_NW_DATA, payload: userDetail });  
      }
      else
      payload = { ...initState, isSaved: true, currentAction, isSubmited: true, isSubmitedSuccess: true, loading: false};      
      
      if(userDetail.cardType){
      dispatch({type:types.SAVE_NETWORK_CARDTYPE,payload:userDetail.cardType});  
      }
      // to update resi address from professional detail response
      if (action === "updateProfSubmit" && response.data.applicationNumber !== "") {
        dispatch({ type: types.SAVE_CKYC_DATA, payload: response.data.data, });
      }
      if(userDetail.isDumpBased)
      dispatch(setDumpBased(true));
      errorState = null;
    } else {
      if (response.data.data && response.data.data?.applicationNumber) {
        dispatch({ type: types.SAVE_CKYC_DATA, payload: { applicationNumber: response.data.data.applicationNumber }, });
      }
      if(action==="ChangeNetwork")
      payload = { ...initState, currentAction:"NwUpdFail", isSubmited: true, isSubmitedSuccess: false, loading: false, };
      else     
      payload = { ...initState, currentAction, isSubmited: true, isSubmitedSuccess: false, loading: false, };
      errorState = { errorCode: response.data.statusCode, errorMsg: response.data.message, };
    }


} else {
    payload = { ...initState, currentAction, isSubmited: true, isSubmitedSuccess: false, loading: false, error: response?.data?.message, };
    errorState = null;
  }
  dispatch(funcUpdateAppStateAfterResponse(payload, errorState));
};

export const funcSaveResiAddress = (resiAddrReq, userMobile, currentAction) => async (dispatch) => {
  dispatch({ type: types.LOADING_VIEW_STATE, value: true, });

  const response = await SslService.funcInvokeIngestion2Service(resiAddrReq);
  if (response && response.data) {
    const statusCode = response.data.statusCode;
    if (statusCode === "000" || statusCode === "001" || statusCode === "200" || statusCode === "103") {
      if (response.data?.data?.currentCardType) {
        dispatch(funcSaveIngestion2ServiceResponse(response.data));
        let data = {
          posRequired: response.data?.data?.posRequired,
      }
        dispatch({ type: types.SAVE_SURROGATE_DATA,payload:data});
      }
      payload = {
        ...initState,
        currentAction,
        isSubmited: true,
        isSubmitedSuccess: true,
        onSd2SuccTelOptSndFail: false,
        // screenName: screenName,
        loading: false,
      };
      if(response.data.data.blazeFungibleFlag === 'Y'){
          const fungibleData = {
            fungibleFlag : response.data.data.blazeFungibleFlag, 
            fungibleCurrLimit : response.data.data.fungibleCurrXpos , 
            fungibleIncLimit : response.data.data.fungibleIncLimit
          }
        dispatch({ type: types.SAVE_FUNGIBLE_DATA, payload: fungibleData});
      }
      errorState = null;
      if(response.data?.data?.telcoRequiredFlag==="Y" && statusCode !== "200"){ 
        // **************Telco Start**********
        let inputData = {
          mobileNumber:userMobile,
          applicationNumber:resiAddrReq.applicationNumber.toString(),
        };
        const action = "sendTelcoOtp";
        const responseOtp = await TelcoService.funcSendTelcoOtp(inputData);
        if (responseOtp && responseOtp.data) {
          if (responseOtp.data.statusCode === "000") {
            dispatch({
              type: types.SAVE_TELCO_OTP_GEN,
              payload: { request_id: responseOtp.data?.data?.requestId },
            });
    } else {
            if (responseOtp.data.statusCode === "107") {
              dispatch({
                type: types.SAVE_TELCO_OTP_GEN,
                payload: { request_id: responseOtp.data?.data?.requestId },
              });
            }
            payload = {
              ...initState,
              currentAction: action,
              isSubmited: false,
              isSubmitedSuccess: false,
              onSd2SuccTelOptSndFail: true
            };
            //   if(response.data.statusCode !== "107"){
            //     payload = {...payload, loading: false};
            //   }
            errorState = {
              errorCode: responseOtp.data.statusCode,
              errorMsg: responseOtp.data.message,
            };
          }
        } else{
          payload = {
            ...initState,
            currentAction: action,
            isSubmited: false,
            isSubmitedSuccess: false,
            onSd2SuccTelOptSndFail: true
          };
        }
         //  ***************telco End*********** 
      } /*else {     
        payload = { ...initState, isSaved: true, currentAction, isSubmited: true, isSubmitedSuccess: true, loading: false, };
        errorState = null;
      }*/
      // to update resi address from professional detail response
      //if (response.data.resiAddr && action === "updateProfSubmit") {
      
    } else {
       payload = { ...initState, currentAction, isSubmited: true, isSubmitedSuccess: false, loading: false, };
      errorState = { errorCode: response.data.statusCode, errorMsg: response.data.data?.hsToken ? response.data.data.hsToken : response.data.message, };
    }
  } else {
    payload = { ...initState, currentAction, isSubmited: true, isSubmitedSuccess: false, loading: false, error: response?.data?.message, };
    errorState = null;
  }
  dispatch(funcUpdateAppStateAfterResponse(payload, errorState));
};

export const funcStoreMultiUrl = (panRes) => (dispatch) => {
  dispatch({ type: types.SAVE_MULTURL_DATA, payload: panRes, });
};

export const funcStoreVisionAddress = (panRes) => (dispatch) => {
  if (panRes && panRes.dSignVPlusResiAddress.length > 0) {
    localStorage.setItem("dSignVPlusMotherName", panRes.dSignVPlusMotherName);
    localStorage.setItem("dSignVPlusEmailId", panRes.dSignVPlusEmailId);
    localStorage.setItem("dSignVPlusResiAddress", panRes.dSignVPlusResiAddress);
  }
  dispatch({ type: types.SAVE_VISION_DATA, payload: panRes })
}

export const clearSSLData = () => (dispatch) => {
  dispatch({ type: types.CLEAR_SSL_DATA })
}